import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'

export default function LandingCounter({count}) {
    const [counter,setCounter] = useState(0)

    useEffect(()=> {
        let interval = setInterval(()=>{
           setCounter(prev => prev + 1)
        }, 1)

        if (counter === count) {
            clearInterval(interval)
        }

        return () => clearInterval(interval)
    })
  return (
    <span>{counter}</span>
  )
}
